const AnalysisCategory = Object.freeze({
  PERCENTAGE: 'PERCENTAGE',
  CHANGE: 'CHANGE',
  EXCEED_VALUE: 'EXCEED_VALUE',
  BELOW_VALUE: 'BELOW_VALUE'
})
export default AnalysisCategory
// RESERVE BELOW
